import { gql } from '@apollo/client';

export const GET_ALL_AUCTIONS = gql`
query getAllAuction($page: Int, $pageSize: Int, $orderBy: GenericScalar,$search: String, $filters: AuctionsFilterInput) {
  allAuctions(page: $page, pageSize: $pageSize, search: $search
  orderBy: $orderBy, filters: $filters) {
    data {
      AuctionName
      AuctionStatus
      ClosedTime
      OpeningTime
      AuctionID
      AuctionInfoID
      LocationCode
      Platform
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_CompanyAddress = gql`
query getCompanyAddress {
  allCompanyAddress {
    data {
      LocationCode
      PostalCode
      Country
      City
      Province 
      Street
      UnitNum
    }
  }
}
`;

export const GET_LastAuctionInfobyLocation = gql`
query getLastAuctionInfobyLocation($LocationCode: String, $orderBy: GenericScalar = "-ClosedTime") {
  allAuctions(
    filters: {LocationCode: $LocationCode}
    orderBy: $orderBy
    pageSize: 1
  ) {
    data {
      OpeningTime
      AuctionDescription
      AuctionID
      AuctionInfoID
      AuctionName
      AuctionLots
      AuctionStatus
      City
      BuyerPremium
      ClosedTime
      Country
      HandlingFee
      FinalClosedTime
      HoldingDays
      LocationCode
      PaymentDeadline
      Province
      PostalCode
      Street
      TermsAndCondition
      TaxRate
      TermCondition
      TotalHighBids
      TotalMaxBids
      UnitNum
      WarrantyDDL
      AuctionNotice
      BiddingNotice
    }
  }
}
`;

export const NEW_AUCTIONINFO = gql`
  mutation newAuctionInfo(
    $BuyerPremium: Decimal, 
    $HandlingFee: Decimal, 
    $HoldingDays: Int, 
    $LocationCode: ID, 
    $PaymentDeadline: Int, 
    $TaxRate: Decimal, 
    $TermCondition: ID, 
    $WarrantyDDL: Int,
    $AuctionNotice: String,
    $BiddingNotice: String
  ) {
    upsertAuctioninfo(
      BuyerPremium: $BuyerPremium
      HandlingFee: $HandlingFee
      HoldingDays: $HoldingDays
      LocationCode: $LocationCode
      PaymentDeadline: $PaymentDeadline
      TaxRate: $TaxRate
      TermCondition: $TermCondition
      WarrantyDDL: $WarrantyDDL,
      AuctionNotice: $AuctionNotice,
      BiddingNotice: $BiddingNotice
    ) {
      isCreateOperation
      success
      itemAfterUpsert {
        AuctionInfoID
      }
    }
  }
`;

export const NEW_TERMS = gql`
mutation newTerms($TermsAndCondition: String) {
  upsertAuctiontermcondition(TermsAndCondition: $TermsAndCondition) {
    isCreateOperation
    itemAfterUpsert {
      AuctionTermConditionID
    }
    success
  }
}
`;

export const NEW_AUCTION = gql`
mutation newAuction($ClosedTime: DateTime, $AuctionName: String, 
$AuctionInfoID: ID, $AuctionID: String, $AuctionDescription: String, 
$OpeningTime: DateTime, $AuctionStatus: Int, $RedirectLink: String, 
$Platform: String, $ItemLiveSecond: Int, $BidPerIncreSecond: Int, $FinalPickupDate: Date) {
  upsertAuctiontable(
    AuctionDescription: $AuctionDescription
    AuctionID: $AuctionID
    AuctionInfoID: $AuctionInfoID
    AuctionName: $AuctionName
    ClosedTime: $ClosedTime
    OpeningTime: $OpeningTime
    RedirectLink: $RedirectLink
    Platform: $Platform
    AuctionStatus: $AuctionStatus
    ItemLiveSecond: $ItemLiveSecond
    BidPerIncreSecond: $BidPerIncreSecond
    FinalPickupDate: $FinalPickupDate
  ) {
    success
  }
}
`;

export const GET_AUCTIONBYID = gql`
query GET_AUCTIONBYID($AuctionID: String) {
  oneAuctions(filters: {AuctionID: $AuctionID}) {
    AuctionDescription
    AuctionID
    AuctionInfoID
    AuctionLots
    AuctionName
    RedirectLink
    AuctionStatus
    BuyerPremium
    City
    ClosedTime
    Country
    FinalClosedTime
    HandlingFee
    HoldingDays
    LocationCode
    OpeningTime
    PaymentDeadline
    PostalCode
    Province
    Street
    TaxRate
    TermCondition
    TermsAndCondition
    TotalHighBids
    UnitNum
    TotalMaxBids
    WarrantyDDL
    TotalMaxBids
    TotalHighBids
    Platform
    AuctionNotice
    BiddingNotice
    BidPerIncreSecond
    ItemLiveSecond
    Stagger
    FinalPickupDate
  }
}
`;

export const GET_LOTSBYAUCTION = gql`
query getLotsByAuction($filters: Front_ViewFilterInput, $page: Int, $pageSize: Int, $orderBy: GenericScalar,  $search: String) {
  allFrontView(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    data {
      Bids
      LotID
      LotIDString
      SoldStatus
      item
      Lead
      OriginalItem
      Path
      HighBid
      CustomerID
      FirstName
      LastName
      Path
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_LOTSTATUSAUCTION = gql`
query GET_LOTSTATUSAUCTION($AuctionID: String) {
  allFrontView(
    aggregates: {Price: "sum", LotID: ["max","min"]}
    filters: {AuctionID: $AuctionID}
    groupBy: {AuctionID: true}
  ) {
    aggregateData {
      maxLotID
      minLotID
      sumPrice
    }
  }
}
`;


export const GET_CHECKINCUSTOMERS = gql`
query GET_CHECKINCUSTOMERS($page: Int, $pageSize: Int, $orderBy: GenericScalar, $AuctionID: ID) {
  allAllowAuction(
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    filters: {AuctionID: $AuctionID}
  ) {
    data {
      ID
      ItemBidLimit
      Status
      TotalBidLimit
      CustomerID {
        CustomerID
        FirstName
        LastName
        Email
      }
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_CUSTOMERS = gql`
  query GET_CUSTOMERS($page: Int, $pageSize: Int, $orderBy: GenericScalar, $AuctionID: ID, $search: String) {
    allAllowAuction(
      page: $page
      pageSize: $pageSize
      orderBy: $orderBy
      search: $search
      filters: {AuctionID: $AuctionID}
    ) {
      data {
        ID
        ItemBidLimit
        Status
        TotalBidLimit
        CustomerID {
          CustomerID
          FirstName
          LastName
          Email
        }
      }
      totalCount
      totalPageNum
    }
}
`;

export const GET_BID_AGGREGATES = gql`
query GetBidAggregates($CustomerID: Int!, $AuctionID2: String!) {
  bidAggregates: allBidCheck(
    filters: {CustomerID: $CustomerID, AuctionID: $AuctionID2, ItemStatusIn: [0,2]}
    aggregates: {CusMaxBid: "sum", BidCount: "sum", BidListID: "count"}
    groupBy: {CustomerID: true}
  ) {
    aggregateData {
      sumBidCount
      sumCusMaxBid
      countBidListID
    }
  }
  pending: allBidCheck(
    filters: {CustomerID: $CustomerID, AuctionID: $AuctionID2, ItemStatusIn: [1]}
    aggregates: {CusMaxBid: "sum", BidCount: "sum", BidListID: "count"}
    groupBy: {CustomerID: true}
  ) {
    aggregateData {
      countBidListID
    }
  }
}
`;

export const GET_AUCTIONDASHBOARD = gql`
query GET_AUCTIONDASHBOARD($AuctionID: String , $AuctionID1: ID ) {
  allOnAuction(filters: {AuctionID: $AuctionID}) {
    totalCount
  }
  allAllowAuction(filters: {AuctionID: $AuctionID1}) {
    totalCount
  }
}
`;

export const GET_CURRENCTAUCTIONS = gql`
query GET_CURRENCTAUCTIONS{
  allAuctions(
    orderBy: "OpeningTime"
    filters: {AuctionStatusIn: [1,2,3], Platform: "Official"}
  ) {
    data {
      AuctionName
      AuctionStatus
      OpeningTime
      ClosedTime
      AuctionID
      AuctionInfoID
      LocationCode
      UnitNum
      Street
      Province
      PostalCode
    }
    totalCount
  }
}
`;

export const GET_LIVEIMTECHECK = gql`
query GET_LIVE_CURRENT_ITEMS($cid: ID, $auctionID: ID!, $page: Int, $pageSize: Int) {
  currentOpeningItem(
    auctionID: $auctionID
    page: $page
    pageSize: $pageSize
    cid: $cid
  ) {
    data {
      TimeLeft
      AuctionID
      AuctionStatus
      LotID
      item
      Path
      PackageCondition
      OnAuctionPKID
      MaxBid
      LocationCode
      Lead
      ItemStatus
      ItemCondition
      HighBid
      Description
      CustomerID
      Classification
      Bids
      ActualCloseTime
      WinnerCustomerID
      BidListID
      Views
      Watches
      Price
      Defects
      Difference
      PartsRelated
      TestRelated
    }
  }
}
`;

export const GET_BIDHISTORY_BYCUSTOMERPERAUCTION = gql`
query GET_BIDHISTORY_BYCUSTOMERPERAUCTION($CustomerID: Int, $AuctionID: String, $CustomerID2: String, $page: Int, $pageSize: Int, $orderBy: GenericScalar, $ItemStatusIn: [Int]) {
  allBidCheck(
    filters: {CustomerID: $CustomerID, AuctionID: $AuctionID, ItemStatusIn: $ItemStatusIn}
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    totalCount
    data {
      BidListID
      TotalBidLimit
      PaymentID
      ItemStatus
      ItemBidLimit
      CustomerID
      CusMaxBid
      CusHighBid
      BidLimit
      BidLastTime
      AuctionStatus
      AuctionID
      AllowStatus
      ActualCloseTime
      OriginalItem
      BidCount
      OnAuctionPKID
      LotID
      Lead
      Path
    }
    totalCount
    totalPageNum
  }
  oneAllowAuction(filters: {AuctionID: $AuctionID, CustomerID: $CustomerID2}) {
    ID
    ItemBidLimit
    Status
    TotalBidLimit
  }
}
`;

export const GETITEMBYITEMSTATUS = gql`
query GETITEMBYITEMSTATUS($CustomerID: Int, $AuctionID: String, $page: Int, $pageSize: Int, $orderBy: GenericScalar, $ItemStatusIn: [Int]) {
  allBidCheck(
    filters: {CustomerID: $CustomerID, AuctionID: $AuctionID, ItemStatusIn: $ItemStatusIn}
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
  ) {
    totalCount
    data {
      BidListID
      CusMaxBid
      OnAuctionPKID
    }
    totalCount
    totalPageNum
  }
}
`;


export const UPDATE_ITEMLIMIT = gql`
mutation UPDATE_ITEMLIMIT($BidListID: ID , $BidLimit: Decimal) {
  upsertBidlist(
    BidLimit: $BidLimit
    BidListID: $BidListID
  ) {
    success
  }
}
`;

export const APPOVECUSTOMER = gql`
  mutation APPOVECUSTOMER($ItemBidLimit: Decimal, $TotalBidLimit: Decimal , $ID: ID ) {
    upsertAllowauction(
      ItemBidLimit: $ItemBidLimit
      TotalBidLimit: $TotalBidLimit
      Status: 2
      ID: $ID
    ) {
      success
    }
  }
`;

export const BID1ITEM = gql`
  mutation BID1ITEM($AuctionId: String!, $bidLimitUpdate: Float!, $cid: Int!, $newPrice: Float!, $OAId: Int!) {
    LiveBiddings(
      AuctionId: $AuctionId
      bidLimitUpdate: $bidLimitUpdate
      cid: $cid
      newPrice: $newPrice
      OAId: $OAId
    ) {
      success
    }
  }
`;
export const BID1ITEMADMIN = gql`
  mutation BID1ITEMADMIN($AuctionId: String!, $bidLimitUpdate: Float!, $cid: Int!, $newPrice: Float!, $OAId: Int!, $BidListId: ID!) {
    ApproveBidding(
      AuctionId: $AuctionId
      bidLimitUpdate: $bidLimitUpdate
      cid: $cid
      newPrice: $newPrice
      OAId: $OAId
      BidListId: $BidListId
    ) {
      success
      message
    }
  }
`;

export const DECLINEBID = gql`
  mutation DECLINEBID($cid: Int!, $OAId: Int!, $BidListId: ID!) {
    DeclineBidding(
      cid: $cid
      OAId: $OAId
      BidListId: $BidListId
    ) {
      success
      message
    }
  }
`;

export const GET_BIDHISTORY_PERITEMPERAUCTION = gql`
query GET_BIDHISTORY_PERITEMPERAUCTION($LotID: Int, $AuctionID: String, $ItemStatusIn: [Int], $WatchStatus: Boolean) {
  allBidCheck(
  orderBy: "-CusMaxBid"
    filters: {LotID: $LotID, AuctionID: $AuctionID, ItemStatusIn: $ItemStatusIn, WatchStatus: $WatchStatus}
  ) {
    data {
      BidListID
      TotalBidLimit
      PaymentID
      ItemStatus
      ItemBidLimit
      CustomerID
      FirstName
      LastName
      CusMaxBid
      CusHighBid
      BidLimit
      BidLastTime
      AuctionStatus
      AuctionID
      AllowStatus
      ActualCloseTime
      item
      Lead
      OriginalItem
      BidCount
      LotID
      LotIDString
      Lead
      Path
    }
    totalCount
  }
}
`;

export const GET_CUSTOMERINFO = gql`
query GET_CUSTOMERINFO($CustomerID: ID, $search: String,$filters: Order_ViewFilterInput, $pageSize: Int, $page: Int, $orderBy: GenericScalar) {
  allCustomer(filters: {CustomerID: $CustomerID}) {
    data {
      AuctionFlexCode
      CustomerID
      Email
      FirstName
      LastName
      Phone
      Credit
      Note
      Password
      IsCashPayer
      AccountLevel
      CustomerInfoID {
        CustomerInfoID
        City
        Country
        Province
        Street
        UnitNum
        Fax
        PostalCode
        Notice
      }
      CustomerHiBidInfoID {
        CustomerHiBidInfoID
        City
        Country
        Province
        Street
        UnitNum
        Fax
        PostalCode
        Notice
      }
    }
    totalCount
    totalPageNum
  }
  allOrderView(
    filters: $filters
    orderBy: $orderBy
    search: $search
    page: $page
    pageSize: $pageSize
  ) {
    data {
      AuctionID
      BidderID
      OrderStatus
      LocationCode
      AppointmentTime
      PickUpTime
      Balance
      TotalAmount
      PaymentMethod
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_ALL_CREDIT_LOG = gql`
query GET_ALL_CREDIT_LOG($filters: CreditLogFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String) {
  allCreditLog(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      CreditLogID
      ModifiedAmount
      FinalAmount
      OperDatetime
      Reason
      InvoiceID
    }
  }
}
`;

export const UPDATESTAGGER = gql`
mutation UPDATESTAGGER($AuctionID: String, $Stagger: Int) {
  upsertAuctiontable(AuctionID: $AuctionID, Stagger: $Stagger) {
    success
    itemAfterUpsert {
      ClosedTime
    }
  }
}
`;

export const GETAUCTIONSUM = gql`
query GETAUCTIONSUM($AuctionID: String) {
  allOnlineAuction(
    aggregates: {Bids: "sum", Views: "sum", HighBid: ["sum", "avg"], MaxBid: "sum", Watches: "sum", LotID: "count"}
    filters: {AuctionID: $AuctionID}
    groupBy: {AuctionID: true}
  ) {
    aggregateData {
      sumViews
      sumWatches
      sumBids
      sumMaxBid
      sumHighBid
      countLotID
      avgHighBid
    }
  }
  allAllowAuction(
    aggregates: {ID: "count"}
    groupBy: {AuctionID: true}
    filters: {AuctionID: $AuctionID}
  ) {
    aggregateData {
      countID
    }
  }
}
`;

export const GETALLCUSTOMER = gql`
query GETALLCUSTOMER($page: Int, $pageSize: Int, $orderBy: GenericScalar, $search: String, $filters: CustomerFilterInput) {
  allCustomer(
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
    filters: $filters
  ) {
    data {
      AuctionFlexCode
      Credit
      CustomerID
      Email
      FirstName
      LastName
      Phone
    }
    totalCount
    totalPageNum
  }
}
`;

export const NEWOEMCLIENT = gql`
mutation NEWOEMCLIENT($CompanyName: String, $Email: String, $FirstName: String, $LastName: String, $SellerCode: String) {
  upsertSeller(
    CompanyName: $CompanyName
    Email: $Email
    FirstName: $FirstName
    LastName: $LastName
    SellerCode: $SellerCode
    IsConsignor: false
    IsOEMClient: true
  ) {
    success
  }
}
`;
export const EDITCREDIT = gql`
mutation EDITCREDIT($CustomerID: ID, $Credit: Decimal) {
  upsertCustomer(CustomerID: $CustomerID, Credit: $Credit) {
    isCreateOperation
    success
  }
}
`;

export const CREATE_CREDIT_LOG = gql`
mutation CREATE_CREDIT_LOG($CustomerID: ID, $FinalAmount: Decimal, $InvoiceID: String, $ModifiedAmount: Decimal, $Operator: String, $OperDatetime: DateTime, $OriginAmount: Decimal, $Reason: String) {
  upsertCreditlog(
    CustomerID: $CustomerID
    FinalAmount: $FinalAmount
    InvoiceID: $InvoiceID
    ModifiedAmount: $ModifiedAmount
    Operator: $Operator
    OperDatetime: $OperDatetime
    OriginAmount: $OriginAmount
    Reason: $Reason
  ) {
    success
    isCreateOperation
  }
}
`;

export const EDITCASHPAYER = gql`
mutation EDITCASHPAYER($CustomerID: ID, $IsCashPayer: Boolean) {
  upsertCustomer(CustomerID: $CustomerID, IsCashPayer: $IsCashPayer) {
    isCreateOperation
    success
  }
}
`;
export const EDITACCOUNTLEVEL = gql`
mutation EDITACCOUNTLEVEL($CustomerID: ID, $AccountLevel: Int) {
  upsertCustomer(CustomerID: $CustomerID, AccountLevel: $AccountLevel) {
    isCreateOperation
    success
  }
}
`;

export const EDITNOTICE = gql`
mutation EDITNOTICE($Note: String, $CustomerID: ID) {
  upsertCustomer(Note: $Note, CustomerID: $CustomerID) {
    isCreateOperation
    success
  }
}
`;

export const UPDATEAUCTION = gql`
mutation MyMutation($AuctionDescription: String, $AuctionID: String, $AuctionName: String, $RedirectLink: String, $OpeningTime: DateTime, $ClosedTime: DateTime, $Platform: String, $AuctionStatus: Int) {
  upsertAuctiontable(
    AuctionDescription: $AuctionDescription
    AuctionID: $AuctionID
    AuctionName: $AuctionName
    ClosedTime: $ClosedTime
    OpeningTime: $OpeningTime
    RedirectLink: $RedirectLink
    Platform: $Platform
    AuctionStatus: $AuctionStatus
  ) {
    success
    __typename
  }
}
`;

export const NEWTRANSFERRING = gql`
mutation NEWSHIPPING($From: String, $To: String, $ShippingID: String) {
  upsertItemtransferring(From: $From, To: $To, ShippingID: $ShippingID) {
    success
  }
}
`;

export const SENDTRANSFERRING = gql`
mutation NEWSHIPPING($ShippingID: String, $OrderStatus: Int) {
  upsertItemtransferring(ShippingID: $ShippingID, OrderStatus: $OrderStatus) {
    success
  }
}
`;

export const GETUNSENTTRANSFER = gql`
query GETUNSENTTRANSFER($From: String, $To: String, $OrderStatusIn: [Int] = [0,2]) {
  allItemTransferring(
    filters: {From: $From, To: $To, OrderStatusIn: $OrderStatusIn}
  ) {
    totalCount
    data {
      ShippingID
    }
  }
}
`;

export const GETALLWAITINGTRANSFER = gql`
query GETALLWAITINGTRANSFER($ProcessStatusIn: [String], $page: Int, $pageSize: Int) {
  allQualityInspectionRaw(
    filters: {ProcessStatusIn: $ProcessStatusIn}
    groupBy: {ProcessStatus: true, LocationCode: true}
    aggregates: {ID: "count"}
    page: $page
    pageSize: $pageSize
  ) {
    aggregateData {
      countID
      ProcessStatus
      LocationCode {
        LocationCode
      }
    }
    totalCount
    totalPageNum
  }
}
`;

export const GETALLTRANSFERS = gql`
query GETALLTRANSFERS($page: Int, $pageSize: Int, $filters: ItemTransferringFilterInput, $orderBy: GenericScalar, $search: String) {
  allItemTransferring(
    page: $page
    pageSize: $pageSize
    filters: $filters
    orderBy: $orderBy
    search: $search
  ) {
    data {
      From
      Operator
      OrderStatus
      PrepareTime
      ReceiveTime
      Receiver
      ShippingID
      To
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_ALL_WARRENTY_REQUEST = gql`
query GET_ALL_WARRENTY_REQUEST($filters: WarrantyFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int) {
  allWarranty(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    totalCount
    totalPageNum
    data {
      AuctionNum
      BidCardNum
      ClaimTime
      ContactEmail
      ContactPhone
      CustomerID
      Detail
      InvoiceID
      ProcessingStatus
      Reason
      WarrantyID
      item
    }
  }
}
`;

export const GET_ORG_ITEM_ARCHIVED_AUCTION = gql`
query GET_ORG_ITEM_ARCHIVED_AUCTION($filters: ArchiedAuctionFilterInput) {
  oneArchiedAuction(filters: $filters) {
    item
    OriginalItem
  }
}
`;

export const GET_ALL_INVOICES = gql`
query GET_ALL_INVOICES($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: Front_ViewFilterInput) {
  allFrontView(
    groupBy: {AppointmentTime: true, AuctionID: true, BidderID: true, FirstName: true, LastName: true, OrderStatus: true, Balance: true, AssignedStatus: true, PickUpTime: true, CustomerID: true}
    aggregates: {LotID: "count", HighBid: "sum"}
    pageSize: $pageSize
    page: $page
    search: $search
    orderBy: $orderBy
    filters: $filters
  ) {
    aggregateData {
      countLotID
      sumHighBid
      AppointmentTime
      AssignedStatus
      AssignedTime
      AuctionID
      AppointmentTime
      Balance
      BidderID
      BuyerPremium
      CustomerID
      Defects
      Description
      Difference
      Email
      FLocation
      FinalClosedTime
      FirstName
      FrontDesk
      HandlingFee
      HighBid
      Inspector
      InvoiceID
      LastName
      LocationCode
      OrderStatus
      Phone
      PickUpTime
      PrepareTime
      RequireShipping
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_ALL_ORDERS = gql`
query GET_ALL_ORDERS($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: Order_ViewFilterInput) {
  allOrderView(
    pageSize: $pageSize
    page: $page
    search: $search
    orderBy: $orderBy
    filters: $filters
  ) {
    data {
      AppointmentTime
      AssignedStatus
      AssignedTime
      AuctionID
      Balance
      BidderID
      CustomerID
      Email
      FLocation
      FirstName
      FrontDesk
      HandlingFee
      InvoiceID
      LastName
      LocationCode
      OrderStatus
      Phone
      PickUpTime
      PrepareTime
      RequireShipping
      TotalAmount
      TotalItemCount
      Platform
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_COUNT_ITEMS_ORDER_STAT = gql`
query GET_COUNT_ITEMS_ORDER_STAT($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: Front_ViewFilterInput) {
  allFrontView(
    groupBy: {OrderStatus: true}
    aggregates: {LotID: "count"}
    pageSize: $pageSize
    page: $page
    search: $search
    orderBy: $orderBy
    filters: $filters
  ) {
    totalCount
    aggregateData {
      countLotID
      OrderStatus
    }
  }
}
`;

export const GET_COUNT_ORDERS_ORDER_STAT = gql`
query GET_COUNT_ORDERS_ORDER_STAT($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: OrderFilterInput) {
  allOrder(
    groupBy: {OrderStatus: true}
    aggregates: {OrderStatus: "count"}
    pageSize: $pageSize
    page: $page
    search: $search
    orderBy: $orderBy
    filters: $filters
  ) {
    totalCount
    aggregateData {
      countOrderStatus
      OrderStatus
    }
  }
}
`;

export const GET_ALL_BOOKED_INVOICES = gql`
query GET_ALL_BOOKED_INVOICES($filters: Order_ViewFilterInput) {
  allOrderView(filters: $filters, pageSize: 300) {
    totalCount
    totalPageNum
    data {
      AppointmentTime
      CustomerID
      FirstName
      LastName
    }
  }
}
`;

export const WARRENTY_REQUEST_DONE = gql`
mutation WARRENTY_REQUEST_DONE($WarrantyID: ID) {
  upsertWarranty(WarrantyID: $WarrantyID, ProcessingStatus: 1) {
    isCreateOperation
    success
  }
}
`;
export const GET_INVOICE_BYITEM = gql`
query GET_INVOICE_BYITEM($item: String) {
  originalItemData: allFrontView(filters: {OriginalItem: $item}) {
    data {
      AuctionID
      BidderID
      InvoiceID
    }
  }
  itemData: allFrontView(filters: {item: $item}) {
    data {
      AuctionID
      BidderID
      InvoiceID
    }
  }
}
`;
export const TRUCKLOAD_SALES = gql`
query TRUCKLOAD_SALES($TruckLoadID: String) {
  totalData: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumPrice
      countID
    }
  }
  auctionData: allInventory(
    filters: {TruckLoadID: $TruckLoadID, SoldOption: "Auction"}
    aggregates: {ID: "count", TotalAmount: "sum"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumTotalAmount
      countID
    }
  }
    listData: allInventory(
    filters: {TruckLoadID: $TruckLoadID, ListPriceIsnull: false}
    aggregates: {ID: "count", ListPrice: "sum"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumListPrice
      countID
    }
  }
}
`;
export const TRUCKLOAD_GETLASTONE = gql`
query TRUCKLOAD_GETLASTONE($ArriveTimeLt: DateTime) {
  allTruckLoad(
    filters: {ArriveTimeLt: $ArriveTimeLt}
    page: 1
    pageSize: 1
    orderBy: "-ArriveTime"
  ) {
    data {
      ArriveTime
      TruckLoadID
    }
  }
}
`;

export const TRUCKLOAD_BYID = gql`
query TRUCKLOAD_BYID($id: ID) {
  oneTruckLoad(id: $id) {
    ArriveTime
    CompleteStatus
    CompleteTime
    FinishedPallet
    IsProcessing
    LaborCost
    PalletCost
    StartTime
    TotalPallet
    TruckLoadID
    Type
    SellerCode {
      FirstName
      LastName
    }
  }
}
`;

export const TRUCKLOAD_SALESANALYSIS = gql`
query TRUCKLOAD_SALESANALYSIS($TruckLoadID: String) {
  totalData: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumPrice
      countID
    }
  }
  salesData: allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckLoadID: true, SoldOption: true}
  ) {
    aggregateData {
      sumUnitPrice
      sumTotalAmount
      countitem
      SoldOption
    }
  }
}
`;
export const TRUCKLOAD_UNSOLDITEM = gql`
query TRUCKLOAD_UNSOLDITEM($TruckLoadID: String) {
  unsoldAvailableData: allUnSoldItems(
    filters: {TruckLoadID: $TruckLoadID, SellingOptionIn: ["0", "AuctionSelection"]}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumPrice
      countID
    }
  }
  unsoldSellingData: allUnSoldItems(
    filters: {TruckLoadID: $TruckLoadID, SellingOptionRegex: "^(?!0$)(?!AuctionSelection$).+"}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumPrice
      countID
    }
  }
}
`;
export const TRUCKLOAD_DEFECTIVE = gql`
query TRUCKLOAD_DEFECTIVE($TruckAndPalletIlike: String) {
  ASIS: allQualityInspectionRaw(
    filters: {ItemCondition: "AS IS", TruckAndPalletIlike: $TruckAndPalletIlike}
  ) {
    totalCount
  }
  Thrown: allQualityInspectionRaw(
    filters: {ProcessStatus: "ThrowItAway", ItemConditionIregex: "[^AS IS]", TruckAndPalletIlike: $TruckAndPalletIlike}
  ) {
    totalCount
  }
}
`;

export const TRUCKLOAD_SALESANALYSIS_PALLET = gql`
query TRUCKLOAD_SALESANALYSIS_PALLET($TruckLoadID: String) {
  allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {item: "count", TotalAmount: "sum"}
    groupBy: {TruckAndPallet: true, Type: true}
  ) {
    aggregateData {
      sumTotalAmount
      countitem
      TruckAndPallet
      Type
    }
  }
}
`;

export const TRUCKLOAD_SALESANALYSIS_PALLETTYPE = gql`
query TRUCKLOAD_SALESANALYSIS_PALLET($TruckLoadID: String) {
  totalData: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {Type: true}
  ) {
    aggregateData {
      sumPrice
      countID
      Type
    }
  }
  totalPalletData: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      sumPrice
      countID
    }
  }
  totalPalletSales: allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {TotalAmount: "sum", item: "count"}
    groupBy: {TruckLoadID: true, Type: true}
  ) {
    aggregateData {
      Type
      sumTotalAmount
      countitem
    }
  }
  allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {Type: true, SoldOption: true}
  ) {
    aggregateData {
      SoldOption
      sumUnitPrice
      sumTotalAmount
      countitem
      Type
    }
  }
}
`;

export const TRUCKLOAD_SALESANALYSIS_PAYMENT = gql`
query TRUCKLOAD_SALESANALYSIS_PAYMENT($TruckLoadID: String) {
  allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {item: "count", TotalAmount: "sum"}
    groupBy: {PaymentMethod: true}
  ) {
    aggregateData {
      sumTotalAmount
      countitem
      PaymentMethod
    }
  }
}
`;

export const TRUCKLOAD_SALESANALYSIS_PALLETBREAKDOWN = gql`
query TRUCKLOAD_SALESANALYSIS_PALLETBREAKDOWN($TruckAndPallet: String) {
  allSalesAnalysis(
    filters: {TruckAndPalletIlike: $TruckAndPallet}
    aggregates: {item: "count", TotalAmount: "sum"}
    groupBy: {SoldOption: true}
  ) {
    aggregateData {
      sumTotalAmount
      countitem
      SoldOption
    }
  }
  unSold: allInventory(
    filters: {TruckAndPalletIlike: $TruckAndPallet, SellingOptionIn: ["0", "AuctionSelection"]}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      sumPrice
      countID
      TruckAndPallet
    }
  }
}
`;

export const TRUCKLOAD_SALESAMALYSIS_CLASS = gql`
query TRUCKLOAD_SALESAMALYSIS_CLASS($TruckLoadID: String) {
  allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {item: "count", TotalAmount: "sum"}
    groupBy: {Type: true, Classification: true, SoldOption: true}
  ) {
    aggregateData {
      sumTotalAmount
      countitem
      Type
      Classification
      SoldOption
    }
  }
}
`;

export const TRUCKLOAD_SALES_BYTYPE = gql`
query TRUCKLOAD_SALES_BYTYPE($TruckLoadID: String) {
  totalData: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckLoadID: true, Type: true}
  ) {
    aggregateData {
      sumPrice
      countID
      Type
      TruckLoadID
    }
  }
  palletCount:allPallet(
    groupBy: {TruckLoadID: true, Type: true}
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {IsProcessing: ["count"]}
  ) {
    aggregateData {
      Type
      TruckLoadID
      countIsProcessing
    }
  }
  auctionData: allInventory(
    filters: {TruckLoadID: $TruckLoadID, SoldOption: "Auction"}
    aggregates: {ID: "count", TotalAmount: "sum"}
    groupBy: {TruckLoadID: true, Type: true}
  ) {
    aggregateData {
      sumTotalAmount
      countID
      Type
      TruckLoadID
    }
  }

auctionDataRefund: allReturnRefund(
    filters: {TruckLoadID: $TruckLoadID, Status: 1}
    aggregates: {FinalRefundAmount: "sum", Status: "count", TruckLoadID: "count"}
    groupBy: {TruckLoadID: true}
  ) {
    aggregateData {
      TruckLoadID
      sumFinalRefundAmount
      countStatus
    }
  }
}
`;


export const GET_RECENTTRUCKLOAD = gql`
query GET_RECENTTRUCKLOAD($pageSize: Int, $page: Int, $orderBy: GenericScalar, $filters: TruckAndPalletFilterInput, $search: String) {
  allTruckAndPallet(
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
    groupBy: {TruckLoadID: true, ArriveTime: true, Type: true, TotalPallet: true}
    filters: $filters
  ) {
    totalPageNum
    totalCount
    aggregateData {
      ArriveTime
      TruckLoadID
      Type
      TotalPallet
    }
  }
}
`;
export const GET_ALLITEMOFTURCKLOAD = gql`
query GET_ALLITEMOFTURCKLOAD($filters: InventoryFilterInput, $pageSize: Int, $page: Int, $search: String) {
  allInventory(
    filters: $filters
    search: $search
    page: $page
    pageSize: $pageSize
  ) {
    data {
      Admin
      Amount
      AuctionitemID
      Barcode
      Classification
      Comment
      Datetime
      Defects
      Description
      Difference
      ID
      InCart
      Inspector
      ItemCondition
      Lead
      Link
      ListID
      Location
      LocationCode
      MissingStatus
      PartsRelated
      Price
      ReStockStatus
      SellingOption
      TestRelated
      TruckAndPallet
      TruckLoadID
      Type
      item
      Path
      IsConsignor
      LinkSource
      PackageCondition
      PaymentMethod
      ProcessStatus
      Remarks
      SoldOption
      SoldQuantity
      SoldTime
      TotalAmount
      UnitPrice
    }
    totalCount
    totalPageNum
  }
}
`;

export const UPDATETRUCKCOST = gql`
mutation UPDATETRUCKCOST($TruckLoadID: String, $LaborCost: Decimal, $PalletCost: Decimal) {
  upsertTruckload(
    TruckLoadID: $TruckLoadID
    LaborCost: $LaborCost
    PalletCost: $PalletCost
  ) {
    success
  }
}
`;
export const GETSUMBYCONDITION = gql`
query GETSUMBYCONDITION($TruckLoadID: String) {
  pkgCondition: allInventory(
    groupBy: {PackageCondition: true}
    aggregates: {ID: "count"}
    filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      countID
      PackageCondition
    }
  }
  condition: allInventory(
    groupBy: {ItemCondition: true}
    aggregates: {ID: "count"}
    filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      countID
      ItemCondition
    }
  }
}
`;
export const GET_CONSIGNMENT_ITEMS = gql`
query GET_CONSIGNMENT_ITEMS($filters: ConsignmentInventoryFilterInput, $pageSize: Int, $page: Int, $search: String , $orderBy: GenericScalar) {
  allConsignmentInventory(
    filters: $filters
    page: $page
    pageSize: $pageSize
    search: $search
    orderBy : $orderBy
  ) {
    data {
      AuctionitemID
      Classification
      Datetime
      HighBid
      ID
      IsConsignor
      Lead
      Location
      LocationCode
      LotID
      MissingStatus
      LotIDString
      Price
      PickupStatus
      ReturnStatus
      SellingOption
      SoldStatus
      TruckAndPallet
      TruckLoadID
      item
      FirstName
      LastName
      ConsignmentPaymentID
      PayBatchID
      PaidDate
      Path
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_CONSIGNMENT_PRODUCTION_ITEMS = gql`
query GET_CONSIGNMENT_PRODUCTION_ITEMS($filters: ConsignmentProductionInventoryFilterInput, $pageSize: Int, $page: Int, $search: String , $orderBy: GenericScalar) {
  allConsignmentProductionInventory(
    filters: $filters
    page: $page
    pageSize: $pageSize
    search: $search
    orderBy : $orderBy
  ) {
    data {
      AuctionitemID
      Classification
      Datetime
      ID
      IsConsignor
      Lead
      Location
      LocationCode
      MissingStatus
      Price
      PickupStatus
      ReturnStatus
      SellingOption
      TruckAndPallet
      TruckLoadID
      item
      FirstName
      LastName
      Path
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_AUCSELECTION_ITEMS = gql`
query GET_AUCSELECTION_ITEMS($filters: RayInventory_ViewFilterInput, $pageSize: Int, $page: Int, $search: String , $orderBy: GenericScalar) {
  allRayInventoryView(
    filters: $filters
    page: $page
    pageSize: $pageSize
    search: $search
    orderBy : $orderBy
  ) {
    data {
      Admin
      Inspector
      AuctionitemID
      Classification
      Datetime
      ID
      IsConsignor
      Lead
      Location
      LocationCode
      Price
      SellingOption
      TruckAndPallet
      TruckLoadID
      item
      FirstName
      LastName
      EntryTime
      Path
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_INV_DATA = gql`
query GET_INV_DATA($filters: RayInventory_ViewFilterInput, $filtersSelection: RayInventory_ViewFilterInput) {
  production: allRayInventoryView(
    filters: $filters
    aggregates: {ID: "count", Price: "sum"}
    groupBy: {SellingOption: true, InCart: true}
  ) {
    aggregateData {
      countID
      sumPrice
    }
  }
  auctionSelection: allRayInventoryView(
    filters: $filtersSelection
    aggregates: {ID: "count", Price: "sum"}
    groupBy: {SellingOption: true, InCart: true}
  ) {
    aggregateData {
      countID
      sumPrice
    }
  }
}
`;

export const GET_CART_ITEMS = gql`
query GET_CART_ITEMS($filters: RayInventory_ViewFilterInput, $pageSize: Int, $page: Int, $search: String, $orderBy: GenericScalar) {
  allRayInventoryView(
    filters: $filters
    page: $page
    pageSize: $pageSize
    search: $search
    orderBy: $orderBy
  ) {
    data {
      item
      Lead
      Price
      InCart
      Index
      LocationCode
      FirstName
      LastName
      Path
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_FILTERS_CONSIGN = gql`
query GET_FILTERS_CONSIGN($filters: ConsignmentInventoryFilterInput = {InCart: "0"}) {
  classification: allConsignmentInventory(
    groupBy: {Classification: true}
    filters: $filters
  ) {
    aggregateData {
      Classification
    }
  }
  consignor: allConsignmentInventory(
    groupBy: {SellerCode: true, FirstName: true, LastName: true}
    filters: $filters
  ) {
    aggregateData {
      FirstName
      LastName
      SellerCode
    }
  }
  batch: allConsignmentInventory(
    groupBy: {SellerCode: true, FirstName: true, LastName: true, TruckLoadID: true}
    filters: $filters
  ) {
    aggregateData {
      FirstName
      LastName
      SellerCode
      TruckLoadID
    }
  }
  locationCode: allConsignmentInventory(
    groupBy: {LocationCode: true}
    filters: $filters
  ) {
    aggregateData {
      LocationCode
    }
  }
}
`;

export const GET_FILTERS_AUCSELECTION = gql`
query GET_FILTERS_AUCSELECTION {
  classification: allRayInventoryView(
  groupBy: {Classification: true}
  filters: {SellingOption: "AuctionSelection",InCart: "0"}
  ) {
    aggregateData {
      Classification
    }
  }
  batch: allRayInventoryView(
    groupBy: {TruckLoadID: true}
    filters: {SellingOption: "AuctionSelection",InCart: "0"}
  ) {
    aggregateData {
      TruckLoadID
    }
  }
  type: allRayInventoryView(
  groupBy: {Type: true}
  filters: {SellingOption: "AuctionSelection",InCart: "0"}
  ) {
    aggregateData {
      Type
    }
  }
  locationCode: allRayInventoryView(
  groupBy: {LocationCode: true}
  filters: {SellingOption: "AuctionSelection",InCart: "0"}
  ) {
    aggregateData {
      LocationCode
    }
  }
  Price: allRayInventoryView(
    filters: {InCart: "0", SellingOption: "AuctionSelection"}
    aggregates: {Price: ["min", "max"]}
    groupBy: {SellingOption: true, InCart: true}
  ) {
    aggregateData {
      maxPrice
      minPrice
    }
  }
}
`;

export const GET_FILTERS_PERBATCH = gql`
query GET_FILTERS_PERBATCH($TruckLoadID:String) {
  classification: allInventory(
  groupBy: {Classification: true}
  filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      Classification
    }
  }
  soldOption: allInventory(
    groupBy: {SoldOption: true}
    filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      SoldOption
    }
  }
  paymentOption: allInventory(
    groupBy: {PaymentMethod: true}
    filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      PaymentMethod
    }
  }
  type: allInventory(
  groupBy: {Type: true}
  filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      Type
    }
  }
  locationCode: allInventory(
  groupBy: {LocationCode: true}
  filters: {TruckLoadID: $TruckLoadID}
  ) {
    aggregateData {
      LocationCode
    }
  }
  Price: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    groupBy: {TruckLoadID: true}
    aggregates: {Price: ["min", "max"]}
  ) {
    aggregateData {
      maxPrice
      minPrice
    }
  }
}`;

export const GET_FILTERS_PRODUCTIONPOOL = gql`
query GET_FILTERS_PRODUCTIONPOOL {
  classification: allRayInventoryView(
  groupBy: {Classification: true}
  filters: {SellingOption: "0",InCart: "0"}
  ) {
    aggregateData {
      Classification
    }
  }
  batch: allRayInventoryView(
    groupBy: {TruckLoadID: true}
    filters: {SellingOption: "0",InCart: "0"}
  ) {
    aggregateData {
      TruckLoadID
    }
  }
  type: allRayInventoryView(
  groupBy: {Type: true}
  filters: {SellingOption: "0",InCart: "0"}
  ) {
    aggregateData {
      Type
    }
  }
  locationCode: allRayInventoryView(
  groupBy: {LocationCode: true}
  filters: {SellingOption: "0",InCart: "0"}
  ) {
    aggregateData {
      LocationCode
    }
  }
  Price: allRayInventoryView(
    filters: {InCart: "0", SellingOption: "0"}
    aggregates: {Price: ["min", "max"]}
    groupBy: {SellingOption: true, InCart: true}
  ) {
    aggregateData {
      maxPrice
      minPrice
    }
  }
}`;

export const GET_NOT_DISPATCHED_ITEMS = gql`
query GET_NOT_DISPATCHED_ITEMS($filters: BigFuckingViewFilterInput, $pageSize: Int, $page: Int, $search: String) {
  allBigFuckingView(filters: $filters,
    search: $search,
    page: $page,
    pageSize: $pageSize
    orderBy: "Datetime"
    ) {
    totalCount
    totalPageNum
    data {
      ID
      item
      Location
      LocationCode
      Inspector
      Dispatcher
      DispatchTime
      Datetime
      AuctionitemID
      TruckAndPallet
    }
  }
}
`;

export const GET_CONSIGN_SALES = gql`
query GET_CONSIGN_SALES {
  total: allConsignmentInventory(
    aggregates: {HighBid: "sum", ID: "count"}
    groupBy: {SellerCode: true, FirstName: true, LastName: true}
  ) {
    aggregateData {
      SellerCode
      FirstName
      LastName
      sumHighBid
      countID
    }
  }
  sold: allConsignmentInventory(
    aggregates: {HighBid: "sum", ID: "count", Commission: "sum"}
    groupBy: {SellerCode: true, FirstName: true, LastName: true}
    filters: {SoldStatus: "S"}
  ) {
    aggregateData {
      SellerCode
      sumCommission
      sumHighBid
      countID
    }
  }
}
`;
export const UPDATE_BIDLIMIT_TOTAL = gql`
mutation UPDATE_BIDLIMIT_TOTAL($ID: ID, $TotalBidLimit : Decimal) {
  upsertAllowauction(TotalBidLimit: $TotalBidLimit, ID: $ID) {
    success
  }
}
`;

export const UPDATEALLOWAUCTION = gql`
mutation UPDATEALLOWAUCTION($ID: ID, $TotalBidLimit: Decimal, $ItemBidLimit: Decimal, $Status: Int ) {
  upsertAllowauction(
    TotalBidLimit: $TotalBidLimit
    ID: $ID
    ItemBidLimit: $ItemBidLimit
    Status: $Status
  ) {
    success
  }
}
`;
export const GETPAYMENTSTATUS = gql`
query GETPAYMENTSTATUS($AuctionID: ID, $InvoiceIDIlike: String) {
  allOrder(
    aggregates: {Balance: "sum", TotalAmount: "sum"}
    filters: {AuctionID: $AuctionID}
    groupBy: {AuctionID: true, PaymentMethod: true}
  ) {
    aggregateData {
      sumBalance
      sumTotalAmount
      PaymentMethod
    }
  }
  total: allOrder(
    aggregates: {Balance: "sum", TotalAmount: "sum"}
    filters: {AuctionID: $AuctionID}
    groupBy: {AuctionID: true}
  ) {
    aggregateData {
      sumBalance
      sumTotalAmount
    }
  }
  credit: allCreditLog(
    aggregates: {ModifiedAmount: "sum"}
    filters: {InvoiceIDIlike: $InvoiceIDIlike}
    groupBy: {Operator: true}
  ) {
    aggregateData {
      sumModifiedAmount
    }
  }
}
`;
export const GETUNPAIDINVOICE = gql`
query GETUNPAIDINVOICE($AuctionID: ID, $page: Int, $pageSize: Int) {
  allOrder(
    page: $page
    pageSize: $pageSize
    filters: {AuctionID: $AuctionID, BalanceGt: "0"}
    orderBy: "InvoiceID"
  ) {
    totalCount
    totalPageNum
    data {
      InvoiceID
      CustomerID {
        PrimaryPaymentID
        CustomerID
      }
    }
  }
}
`;

export const GETBIDCHECKADMIN = gql`
query GETBIDCHECKADMIN($AuctionID: String, $orderBy: GenericScalar, $page: Int, $pageSize: Int,$search: String) {
  allBidCheckAdmin(
    filters: {AuctionID: $AuctionID}
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalPageNum
    totalCount
    data {
      AllowStatus
      AuctionID
      CustomerID
      Name
      ID
      ItemBidLimit
      TotalBidCount
      TotalBidLimit
      TotalCusHighBid
      TotalCusMaxBid
      TotalItemStatusPending
    }
  }
}
`;

export const GETOEMTRUCK = gql`
query GETOEMTRUCK($filters: OEMTruckFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String) {
  allOEMTruck(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      ArriveTime
      CompleteStatus
      CompleteTime
      FirstName
      IsConsignor
      IsOEMClient
      IsProcessing
      LaborCost
      LastName
      PalletCost
      SellerCode
      ServiceFee
      StartTime
      TotalPallet
      TruckLoadID
      Type
      FinishedPercen
      IP
    }
  }
}`

export const GETOEMSELLERCODE = gql`
query GETOEMSELLERCODE {
  allSeller(filters: {IsOEMClient: true}) {
    data {
      CompanyName
      FirstName
      LastName
      SellerCode
      IP
    }
  }
}`

export const GETCONSIGNMENTSELLERCODE = gql`
query GETOEMSELLERCODE {
  allSeller(filters: {IsConsignor: true}) {
    data {
      CompanyName
      FirstName
      LastName
      SellerCode
      IP
    }
  }
}`

export const GETTRUCK = gql`
query GETTRUCK($filters: TruckLoadFilterInput) {
  allTruckLoad(filters: $filters) {
    data {
      ArriveTime
      CompleteStatus
      CompleteTime
      IsProcessing
      LaborCost
      PalletCost
      SellerCode {
        SellerCode
      }
      ServiceFee
      StartTime
      TotalPallet
      TruckLoadID
      Type
    }
  }
}`

export const GETSELLERCODE = gql`
query GETSELLERCODE($UserName: String) {
  oneSeller(filters: {UserName: $UserName, IsOEMClient: true}) {
    SellerCode
  }
}`

export const TRUCKITEMTRACK = gql`
query TRUCKITEMTRACK($TruckAndPalletIlike: String) {
  allQualityInspectionRaw(
    groupBy: {ProcessStatus: true}
    aggregates: {ID: "count"}
    filters: {TruckAndPalletIlike: $TruckAndPalletIlike}
  ) {
    aggregateData {
      countID
      ProcessStatus
    }
  }
}
`

export const ALLOEMITEM = gql`
query ALLOEMITEM($page: Int, $pageSize: Int, $filters: OEMPoolFilterInput, $orderBy: GenericScalar, $search: String) {
  allOEMPool(
    page: $page
    pageSize: $pageSize
    filters: $filters
    orderBy: $orderBy
    search: $search
  ) {
    data {
      Admin
      Amount
      AuctionitemID
      Barcode
      Classification
      Comment
      Defects
      Datetime
      Description
      Difference
      EntryTime
      FirstName
      ID
      Inspector
      ItemCondition
      LastName
      Lead
      Link
      Location
      LocationCode
      MissingStatus
      PartsRelated
      Price
      SellerCode
      SellingOption
      TestRelated
      TruckAndPallet
      TruckLoadID
      Type
      item
      Path
    }
    totalCount
    totalPageNum
  }
}
  `
export const NEXTOEMITEM = gql`
query NEXTOEMITEM($page: Int, $pageSize: Int, $filters: OEMPoolFilterInput, $orderBy: GenericScalar) {
  allOEMPool(
    page: $page
    pageSize: $pageSize
    filters: $filters
    orderBy: $orderBy
  ) {
    data {
      ID
      item
    }
  }
}
  `

export const GET_FILTERS_ALLOEMITEM = gql`
query GET_FILTERS_ALLOEMITEM($filters: OEMPoolFilterInput) {
  classification: allOEMPool(
    groupBy: {Classification: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      Classification
      countID
    }
  }
  batch: allOEMPool(
    groupBy: {TruckLoadID: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      TruckLoadID
      countID
    }
  }
  type: allOEMPool(
    groupBy: {Type: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      Type
      countID
    }
  }
  locationCode: allOEMPool(
    groupBy: {LocationCode: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      LocationCode
      countID
    }
  }
  admin: allOEMPool(
    groupBy: {Admin: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      Admin
      countID
    }
  }
  inspector: allOEMPool(
    groupBy: {Inspector: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      countID
      Inspector
    }
  }
}
  `;


export const GETOEMITEMDETAIL = gql`
query GETOEMITEMDETAIL($id: ID) {
  oneOEMPool(id: $id) {
    Admin
    Amount
    AuctionitemID
    Barcode
    Classification
    Comment
    Datetime
    Defects
    Description
    Difference
    EntryTime
    FirstName
    ID
    Inspector
    ItemCondition
    LastName
    Lead
    Link
    Location
    LocationCode
    MissingStatus
    PartsRelated
    Price
    SellerCode
    SellingOption
    TestRelated
    TruckAndPallet
    TruckLoadID
    Type
    item
    PackageCondition
    ProcessStatus
  }
}
  `;

export const APPROVEOEMITEM = gql`
mutation APPROVEOEMITEM($AprovedAdmin: String, $ID: String, $item: String) {
  upsertOemapporve(
    ApproveStaus: true
    AprovedAdmin: $AprovedAdmin
    ID: $ID
    item: $item
  ) {
    success
  }
}
  `;

export const GET_CONSIGNMENT_PAYABLE = gql`
query GET_CONSIGNMENT_PAYABLE(
    $filters: ConsignmentPayableFilterInput, 
    $orderBy: GenericScalar,
    $page: Int,
    $pageSize: Int,
    $search: String
  ) {
  allConsignmentPayable(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      SellerCode
      FirstName
      LastName
      LocationCode
      TotalHighBid
      TotalCommission
      TotalRefundAmount
      NetPayable
      CountItem
    }
  }
}
`;

export const GET_CONSIGNMENT_PAYMENT_BATCH = gql`
query GET_CONSIGNMENT_PAYMENT_BATCH($filters: ConsignmentPaymentBatchFilterInput, $page: Int, $pageSize: Int, $search: String, $orderBy: GenericScalar) {
  allConsignmentPaymentBatch(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      FirstName
      LastName
      PayBatchID
      SellerCode
      TotalAmount
      TotalCommission
      TotalHighBid
      PayStatus
      GeneratedDate
      PaidDate
      Comment
    }
  }
}
`;

export const MUTATE_CONSIGNMENT_PAYMENT_BATCH = gql`
mutation MUTATE_CONSIGNMENT_PAYMENT_BATCH($Comment: String, $FirstName: String, $LastName: String, $SellerCode: String, $TotalAmount: Decimal, $TotalCommission: Decimal, $TotalHighBid: Decimal, $TotalRefundAmount: Decimal, $PayBatchID: ID, $PayStatus: Int, $PaidDate: DateTime, $GeneratedDate: DateTime) {
  upsertConsignmentpaymentbatch(
    Comment: $Comment
    FirstName: $FirstName
    LastName: $LastName
    SellerCode: $SellerCode
    TotalAmount: $TotalAmount
    TotalCommission: $TotalCommission
    TotalHighBid: $TotalHighBid
    TotalRefundAmount: $TotalRefundAmount
    PayBatchID: $PayBatchID
    PayStatus: $PayStatus
    PaidDate: $PaidDate
    GeneratedDate: $GeneratedDate
  ) {
    success
    isCreateOperation
    itemAfterUpsert {
      PayBatchID
    }
  }
}
`;

export const DELETE_CONSIGNMENT_PAYMENT_BATCH = gql`
mutation DELETE_CONSIGNMENT_PAYMENT_BATCH($PayBatchID: ID) {
  deleteConsignmentpaymentbatch(PayBatchID: $PayBatchID) {
    success
  }
}
`;

export const GET_ALL_CONSIGNOR = gql`
query GET_ALL_CONSIGNOR($filters: SellerFilterInput, $page: Int, $pageSize: Int, $search: String, $orderBy: GenericScalar) {
  allSeller(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      FirstName
      LastName
      SellerCode
      IsOEMClient
      IsConsignor
      Email
      CompanyName
      ServiceFee
      HandlingFee
      UserName
      Balance
      TruckLoad {
        TruckLoadID
      }
    }
  }
}
`;

export const MUTATE_CONSIGNOR = gql`
mutation MUTATE_CONSIGNOR($FirstName: String, $LastName: String, $SellerCode: String, $Email: String, $CompanyName: String, $HandlingFee: Decimal, $ServiceFee: Decimal, $UserName: String) {
  upsertSeller(
    FirstName: $FirstName
    LastName: $LastName
    SellerCode: $SellerCode
    CompanyName: $CompanyName
    Email: $Email
    HandlingFee: $HandlingFee
    ServiceFee: $ServiceFee
    UserName: $UserName
    IsConsignor: true
  ) {
    success
    isCreateOperation
  }
}
`;

export const ALTER_SELLER_BALANCE = gql`
mutation ALTER_SELLER_BALANCE($SellerCode: ID!, $BalanceAlterAmount: Decimal!) {
  sellerBalanceAlter(
    BalanceAlterAmount: $BalanceAlterAmount
    SellerCode: $SellerCode
  ) {
    message
    success
  }
}
`;

export const GET_ITEM_IN_PAY_BATCH = gql`
query GET_ITEM_IN_PAY_BATCH($filters: ConsignmentPaymentFilterInput, $page: Int, $pageSize: Int, $search: String, $orderBy: GenericScalar) {
  allConsignmentPayment(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      PayBatchID
      item
      paid
      HighBid
      Commission
      ID {
        Lead
        item
      }
    }
  }
}
`;

export const GETREFUNDINVOICE = gql`
query GETREFUNDINVOICE($filters: Return_ViewFilterInput, $page: Int, $pageSize: Int, $orderBy: GenericScalar, $search: String) {
  allReturnView(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      InvoiceNum
      InvoiceID
      AuctionID
      BidderID
      TotalRefundAmount
      EarliestReturnTime
      Status
      ItemCount
      FrontdeskList
    }
  }
}`

export const GETINVOICENUM = gql`
query GETINVOICENUM($filters: Return_RefundFilterInput, $groupBy: Return_RefundGroupByInput = {InvoiceID: true, InvoiceNum: true}) {
  allReturnRefund(filters: $filters, groupBy: $groupBy) {
    aggregateData {
      InvoiceID
      InvoiceNum
    }
  }
}
`

export const GETHISTORYREFUNDDECLINEITEMS = gql`
query GETHISTORYREFUNDDECLINEITEMS($page: Int, $pageSize: Int, $orderBy: GenericScalar, $filters: Return_RefundFilterInput, $search: String) {
  allReturnRefund(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    data {
      InvoiceNum
      AuctionID
      BidderID
      InvoiceID
      item
      ReturnTime
      FrontDesk
      Reason
      Responsible
      RefundTime
      FinalRefundAmount
      Admin
      Status
    }
    totalCount
    totalPageNum
  }
}
`

export const GETALLRESPONSIBLE = gql`
query GETALLRESPONSIBLE($orderBy: GenericScalar = "UserName", $filters: UserFilterInput = {UserTypeIn: ["FrontDesk", "Dispatcher", "QualityInspector", "Admin"], ActiveStatus: 1}, $pageSize: Int) {
  allUser(orderBy: $orderBy, filters: $filters, pageSize: $pageSize) {
    data {
      UserName
    }
  }
}`
export const GETALLRESPONSIBLECOUNT = gql`
query GETALLRESPONSIBLECOUNT($filters: UserFilterInput = {UserTypeIn: ["FrontDesk", "Dispatcher", "QualityInspector", "Admin"], ActiveStatus: 1}) {
  allUser(filters: $filters) {
    totalCount
  }
}`

export const GETONEINVOICEREFUNDAMOUNT = gql`
query GETONEINVOICEREFUNDAMOUNT($filters: Return_ViewFilterInput) {
  oneReturnView(filters: $filters) {
    TotalRefundAmount
  }
}
`


export const GETCLOSEDAUCTIONHIGHBIDSUM = gql`
query GETCLOSEDAUCTIONHIGHBIDSUM($filters: OnAuctionFilterInput, $page: Int, $pageSize: Int, $groupBy: OnAuctionGroupByInput = {AuctionStatus: true, Platform: true, AuctionID: true}, $orderBy: GenericScalar, $aggregates: OnAuctionAggregateInput = {HighBid: "sum", AuctionID: "count", OriginalClosedTime: "min"}) {
  allOnAuction(
    groupBy: $groupBy
    filters: $filters
    aggregates: $aggregates
    pageSize: $pageSize
    page: $page
    orderBy: $orderBy
  ) {
    aggregateData {
      AuctionID
      sumHighBid
      AuctionStatus
      Platform
      countAuctionID
      minOriginalClosedTime
    }
    totalPageNum
    totalCount
  }
}
`

export const GETCLOSEDAUCTIONREFUNDDATA = gql`
query GETCLOSEDAUCTIONREFUNDDATA($filters: Return_RefundFilterInput, $groupBy: Return_RefundGroupByInput = {AuctionID: true, Status: true}, $aggregates: Return_RefundAggregateInput = {FinalRefundAmount: "sum", AuctionID: "count"}, $pageSize: Int) {
  allReturnRefund(
    groupBy: $groupBy
    aggregates: $aggregates
    filters: $filters
    pageSize: $pageSize
  ) {
    totalPageNum
    totalCount
    aggregateData {
      Status
      sumFinalRefundAmount
      AuctionID
      countAuctionID
    }
  }
}
`

export const GETINVOICEITEMLIST = gql`
query GETINVOICEITEMLIST($filters: Archived_Front_ViewFilterInput) {
  allArchivedFrontView(filters: $filters) {
    data {
      AuctionID
      BidderID
      Description
      FinalRefundAmount
      HighBid
      Lead
      MissingStatus
      OnAuctionPKID
      OriginalItem
      PickupStatus
      PrepareStatus
      ReturnStatus
      item
      ScanStatus
    }
  }
}`
export const GETINVOICEGENERALINFO = gql`
query GETINVOICEGENERALINFO($filters: Order_ViewFilterInput) {
  oneOrderView(filters: $filters) {
    HoldingDDL
    CustomerID
    InvoiceID
    LocationCode
    RequireShipping
    FirstName
    LastName
    AppointmentTime
    FLocation
    Operator
    TotalAmount
    FrontDesk
    AssignedStatus
    OrderStatus
    Platform
    PaymentRefID
    Balance
    PaymentMethod
  }
}`

export const GETTRUCKLOADID = gql`
query GETTRUCKLOADID($filters: Quality_Inspection_RawFilterInput) {
  oneQualityInspectionRaw(filters: $filters) {
    TruckAndPallet
  }
}`



export const GET_USERS = gql`
query GET_USERS($filters: UserFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String) {
  allUser(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    data {
      ActiveStatus
      LastLoginTime
      LocationCode {
        LocationCode
      }
      OnlineStatus
      UserID
      UserName
      UserType
    }
    totalCount
    totalPageNum
  }
}`

export const UPSERTUSER = gql`
mutation UPSERTUSER($LocationCode: ID, $Password: String, $UserName: String, $UserType: String, $OnlineStatus: Int, $ActiveStatus: Int, $LastLoginTime: DateTime, $UserID: ID, $Judgement: Int) {
  upsertUser(
    LocationCode: $LocationCode
    Password: $Password
    UserName: $UserName
    UserType: $UserType
    ActiveStatus: $ActiveStatus
    OnlineStatus: $OnlineStatus
    LastLoginTime: $LastLoginTime
    UserID: $UserID
    Judgement: $Judgement
  ) {
    success
  }
}`

export const GETLOCATIONDETAIL = gql`
query GETLOCATIONDETAIL($orderBy: GenericScalar ) {
  allCompanyAddress(orderBy: $orderBy) {
    data {
      AllowDoubleDays
      AppointmentStagger
      City
      CloseAt
      ContactEmail
      ContactPhone
      Country
      LocationCode
      OpenFrom
      PostalCode
      Province
      Street
      UnitNum
      WorkingDays
    }
    totalCount
    totalPageNum
  }
}`

export const UPSERT_LOCATION = gql`
mutation UPSERT_LOCATION($AllowDoubleDays: String, $AppointmentStagger: Int, $City: String, $CloseAt: String, $ContactEmail: String, 
$ContactPhone: String, $Country: String, $LocationCode: String, $OpenFrom: String, $PostalCode: String, 
$Province: String, $Street: String, $UnitNum: String, $WorkingDays: String) {
  upsertCompanyaddress(
    AllowDoubleDays: $AllowDoubleDays
    AppointmentStagger: $AppointmentStagger
    City: $City
    CloseAt: $CloseAt
    ContactEmail: $ContactEmail
    ContactPhone: $ContactPhone
    LocationCode: $LocationCode
    OpenFrom: $OpenFrom
    PostalCode: $PostalCode
    Province: $Province
    Street: $Street
    UnitNum: $UnitNum
    WorkingDays: $WorkingDays
    Country: $Country
  ) {
    success
  }
}`

export const GETTOTALHIGHBIDANDREFUN = gql`
query GETTOTALHIGHBIDANDREFUN(
  $filters: AuctionTableFilterInput, 
  $aggregates: AuctionTableAggregateInput = {TotalHighBids: "sum"}, 
  $groupBy: AuctionTableGroupByInput = {AuctionStatus: true}, 
  $filters1: Return_RefundFilterInput, 
  $aggregates1: Return_RefundAggregateInput = {FinalRefundAmount: "sum"}, 
  $groupBy1: Return_RefundGroupByInput = {Status: true}) {
    allAuctionTable(filters: $filters, aggregates: $aggregates, groupBy: $groupBy) {
      aggregateData {
        sumTotalHighBids
      }
    }
    allReturnRefund(
      filters: $filters1
      aggregates: $aggregates1
      groupBy: $groupBy1
    ) {
      aggregateData {
        sumFinalRefundAmount
      }
    }
}`

export const GETTARGETITEM = gql`
query GETTARGETITEM($item: String,
$auctionID:String,
$bidderID:String,
  ) {
  originalItemData: allReturnRefund(filters: {OriginalItem: $item}) {
    data {
      AuctionID
      BidderID
      InvoiceID
    }
  }
  itemData: allReturnRefund(filters: {item: $item}) {
    data {
      AuctionID
      BidderID
      InvoiceID
    }
  }
    InvoiceData: allReturnRefund(filters: {AuctionID:$auctionID,BidderID:$bidderID}
    groupBy:{AuctionID:true,BidderID:true,InvoiceID:true}
    ) {
    aggregateData {
      AuctionID
      BidderID
      InvoiceID
    }
  }
}`

export const GET_ALL_AUCTION_TABLE = gql`
  query GET_ALL_AUCTION_TABLE($page: Int, $pageSize: Int, $orderBy: GenericScalar, $search: String, $filters: AuctionTableFilterInput) {
    allAuctionTable(page: $page, pageSize: $pageSize, search: $search
    orderBy: $orderBy, filters: $filters) {
      data {
        AuctionName
        ClosedTime
        AuctionID
        Platform
        FinalPickupEmailSendAmount
      }
      totalCount
      totalPageNum
    }
  }
`;

export const GET_ALL_EMAIL_TEMPLATE = gql`
query GET_ALL_EMAIL_TEMPLATE($page: Int, $pageSize: Int, $orderBy: GenericScalar, $search: String, $filters: EmailTemplateFilterInput) {
  allEmailTemplate(page: $page, pageSize: $pageSize, orderBy: $orderBy, search: $search, filters: $filters) {
    totalCount
    totalPageNum
    data {
      BodyHtml
      BodyPlain
      EmailTemplateID
      Name
      Subject
    }
  }
}
`;

export const UPSERT_EMAIL_TEMPLATE = gql`
mutation UPSERT_EMAIL_TEMPLATE($BodyHtml: String, $BodyPlain: String, $Name: String, $EmailTemplateID: ID, $Subject: String) {
  upsertEmailtemplate(
    EmailTemplateID: $EmailTemplateID
    Name: $Name
    Subject: $Subject
    BodyHtml: $BodyHtml
    BodyPlain: $BodyPlain
  ) {
    isCreateOperation
    success
    itemAfterUpsert {
      EmailTemplateID
      Name
      Subject
      BodyHtml
      BodyPlain
    }
  }
}
`;

export const DELETE_EMAIL_TEMPLATE = gql`
mutation DELETE_EMAIL_TEMPLATE($EmailTemplateID: ID) {
  deleteEmailtemplate(EmailTemplateID: $EmailTemplateID) {
    success
  }
}
`;

export const GET_ONE_EMAIL_TASK = gql`
query GET_ONE_EMAIL_TASK($filters: EmailTaskFilterInput) {
  oneEmailTask(filters: $filters) {
    WorkingOnIndex
    TotalEmailSent
    TaskStatus
    TaskName
    TaskStartTime
    TaskEndTime
    EmailTaskID
  }
}
`;

export const GET_ALL_IMPORTANT_NOTICE = gql`
query GET_ALL_IMPORTANT_NOTICE($filters: ImportantNoticeFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String) {
  allImportantNotice(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      NoticeID
      Title
      Content
      EntryTime
      ActiveStatus
    }
  }
}`;

export const UPSERT_IMPORTANT_NOTICE = gql`
mutation UPSERT_IMPORTANT_NOTICE($ActiveStatus: Int, $Content: String, $EntryTime: DateTime, $NoticeID: ID, $Title: String) {
  upsertImportantnotice(
    ActiveStatus: $ActiveStatus
    Content: $Content
    EntryTime: $EntryTime
    NoticeID: $NoticeID
    Title: $Title
  ) {
    isCreateOperation
    success
    itemAfterUpsert {
      ActiveStatus
      Content
      EntryTime
      NoticeID
      Title
    }
  }
}`;

export const GETOEMUPDATE = gql`
query GETOEMUPDATE($SellerCode: String) {
  allOEMTransfer(filters: {SellerCode: $SellerCode}) {
    totalCount
  }
}`

export const GET_ITEM_BYLOCATION = gql`
query GET_ITEM_BYLOCATION($Location: String, $page: Int, $pageSize: Int, $search: String) {
  allBigFuckingView(
    filters: {Location: $Location}
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    data {
      item
      Location
      MissingStatus
    }
    totalCount
    totalPageNum
  }
}`

export const CHECK_ITEM_BY_LOCATION = gql`
query CHECK_ITEM_BY_LOCATION($filters: Quality_Inspection_RawFilterInput) {
  allQualityInspectionRaw(
    filters: $filters
  ) {
    data {
      item
    }
  }
}`

export const GETABOUTPAGES = gql`
query GETABOUTPAGES {
  allAboutPage(groupBy: {Page: true}) {
    aggregateData {
      Page
    }
  }
}`

export const GETABOUTPAGESDETAIL = gql`
query GETABOUTPAGESDETAIL($Page: String, $orderBy: GenericScalar = "Index") {
  allAboutPage(filters: {Page: $Page}, orderBy: $orderBy) {
    data {
      Content
      Index
      InfoID
      Page
      SubTitle
    }
  }
}`
export const UPSERTABOUTPAGE = gql`
mutation UPSERTABOUTPAGE($Content: String, $Index: Int, $InfoID: ID, $Page: String, $SubTitle: String) {
  upsertAboutpage(
    Content: $Content
    Index: $Index
    InfoID: $InfoID
    Page: $Page
    SubTitle: $SubTitle
  ) {
    success
  }
}`

export const DELETEABOUTPAGE = gql`
mutation DELETEABOUTPAGE($InfoID: ID) {
  deleteAboutpage(InfoID: $InfoID) {
    success
  }
}`

export const GET_INVOICE_ITEMS_DISPATCHER = gql`
query GET_INVOICE_ITEMS_DISPATCHER($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: Front_ViewFilterInput) {
  allFrontView(
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
    filters: $filters
  ) {
    totalCount
    totalPageNum
    data {
      item
      Lead
      Location
      MissingStatus
      OriginalItem
      PickupStatus
      PrepareStatus
      InvoiceID
      LocationCode
      ScanStatusDispatcher
      FLocation
      OrderStatus
      Path
    }
  }
}`

export const GET_ITEMS_ItemTransferView = gql`
query GET_ITEMS_ItemTransferView($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: ItemTransfer_ViewFilterInput) {
  allItemTransferView(
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
    filters: $filters
  ) {
    totalCount
    totalPageNum
    data {
      From
      ID
      Lead
      Location
      MissingStatus
      Operator
      OrderStatus
      PickupStatus
      PrepareStatus
      PrepareTime
      ReStockStatus
      ReceiveTime
      Receiver
      ScanStatus
      ScanStatusDispatcher
      ShippingID
      To
      item
    }
  }
}`

export const GET_LIST_ITEMS_DISPATCHER = gql`
query GET_LIST_ITEMS_DISPATCHER($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: BigFuckingViewFilterInput) {
  allBigFuckingView(
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
    filters: $filters
  ) {
    totalCount
    totalPageNum
    data {
      ID
      item
      Lead
      Location
      MissingStatus
      PickupStatus
      PrepareStatus
      LocationCode
      ScanStatusDispatcher
      Path
    }
  }
}`

export const GET_INVOICE_ITEMS_FRONTDESK = gql`
query GET_INVOICE_ITEMS_FRONTDESK($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: Archived_Front_ViewFilterInput) {
  allArchivedFrontView(
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
    filters: $filters
  ) {
    totalCount
    totalPageNum
    data {
      item
      Lead
      MissingStatus
      OriginalItem
      PickupStatus
      PrepareStatus
      ScanStatus
      HighBid
      Description
      OnAuctionPKID
      ReturnStatus
    }
  }
}`

export const GET_TEMPLATE_ITEM_CSV = gql`
query GET_TEMPLATE_ITEM_CSV($filters: InventoryFilterInput) {
  allInventory(filters: $filters) {
    data {
      item
      ItemCondition
      Link
      Price
      Lead
      Description
      Classification
      TruckAndPallet
      Barcode
      Location
      PartsRelated
      TestRelated
      Difference
      Defects
      PackageCondition
      Comment
      Path
    }
  }
}`

export const GET_DATAPROCESS = gql`
query GET_DATAPROCESS($filters: Product_PoolFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String ) {
  allProductPool(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    data {
      Admin
      Description
      EntryTime
      Lead
      Price
      item
    }
    totalCount
    totalPageNum
  }
}`

export const GETRETURNEDITEMS = gql`
query GETRETURNEDITEMS($filters: Return_RefundFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String ) {
  allReturnRefund(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    data {
      Admin
      AuctionID
      BidderID
      FinalRefundAmount
      FrontDesk
      InternalComment
      InvoiceID
      InvoiceNum
      LocationCode
      OriginalItem
      Reason
      RefundAmount
      RefundTime
      Responsible
      ReturnID
      ReturnTime
      Status
      TruckLoadID
      item
      Results
    }
    totalCount
    totalPageNum
  }
}`

export const GET_SERVER_CURRENT_TIME = gql`
query GET_SERVER_CURRENT_TIME {
  currentTime
}`

export const GET_PUNCH_RECORD = gql`
query GET_PUNCH_RECORD($filters: PunchRecordFilterInput, $pageSize: Int = 1) {
  allPunchRecord(pageSize: $pageSize, filters: $filters) {
    totalCount
    data {
      PunchRecordID
      PunchInTime
    }
  }
}`

export const PUNCH_IN_RECORD = gql`
mutation PUNCH_IN_RECORD($UserID: Int, $UserName: String, $UserType: String) {
  upsertPunchrecord(
    UserID: $UserID
    UserName: $UserName
    UserType: $UserType
  ) {
    isCreateOperation
    success
  }
}`

export const PUNCH_OUT_RECORD = gql`
mutation PUNCH_OUT_RECORD($PunchRecordID: ID, $PunchOutTime: DateTime, $WorkingHour: Decimal) {
  upsertPunchrecord(
    PunchRecordID: $PunchRecordID
    WorkingHour: $WorkingHour
    PunchOutTime: $PunchOutTime
  ) {
    isCreateOperation
    success
  }
}`

export const GET_ALL_PUNCH_RECORD_AGGREGATE = gql`
query GET_ALL_PUNCH_RECORD($filters: PunchRecordFilterInput, $pageSize: Int, $aggregates: PunchRecordAggregateInput, $groupBy: PunchRecordGroupByInput, $orderBy: GenericScalar, $page: Int, $search: String) {
  allPunchRecord(
    pageSize: $pageSize
    filters: $filters
    aggregates: $aggregates
    groupBy: $groupBy
    orderBy: $orderBy
    page: $page
    search: $search
  ) {
    totalCount
    totalPageNum
    aggregateData {
      UserName
      PunchDate
      sumWorkingHour
      countPunchRecordID
    }
  }
}`

export const CUSTOMER_REGISTER_CONFIRM_EMAIL = gql`
mutation CUSTOMER_REGISTER_CONFIRM_EMAIL($email: String!, $address: String, $city: String, $country: String, $fax: String, $FirstName: String!, $LastName: String!, $MiddleName: String, $NickName: String, 
    $Phone: String, $province: String, $registerPassword: String!, $unit: String, $zip: String, $setPrimaryAddress: Boolean = false) {
  RegisterEmailConfirm(
    email: $email
    address: $address
    city: $city
    country: $country
    fax: $fax
    FirstName: $FirstName
    LastName: $LastName
    MiddleName: $MiddleName
    NickName: $NickName
    Phone: $Phone
    province: $province
    registerPassword: $registerPassword
    unit: $unit
    zip: $zip
    setPrimaryAddress: $setPrimaryAddress
  ) {
    message
    success
  }
}`;

export const CUSTOMER_REGISTER_CONFIRM_EMAIL_F_VAL = gql`
mutation CUSTOMER_REGISTER_CONFIRM_EMAIL_F_VAL($email: String!, $address: String, $city: String, $country: String, $fax: String, $FirstName: String!, $LastName: String!, $MiddleName: String, $NickName: String, 
    $Phone: String, $province: String, $registerPassword: String!, $unit: String, $zip: String, $setPrimaryAddress: Boolean = false) {
  RegisterCreateCustomerFVal(
    email: $email
    address: $address
    city: $city
    country: $country
    fax: $fax
    FirstName: $FirstName
    LastName: $LastName
    MiddleName: $MiddleName
    NickName: $NickName
    Phone: $Phone
    province: $province
    registerPassword: $registerPassword
    unit: $unit
    zip: $zip
    setPrimaryAddress: $setPrimaryAddress
  ) {
    message
    customerID
    success
  }
}`;

export const VERIFY_HIBID_EMAIL = gql`
query VERIFY_HIBID_EMAIL($EmailIexact: String) {
  allCustomer(filters: {EmailIexact: $EmailIexact}) {
    totalCount
    totalPageNum
    data {
      CustomerID
      Email
      FirstName
      MiddleName
      LastName
      CustomerHiBidInfoID {
        CustomerHiBidInfoID
        FirstName
        LastName
        Phone
        Fax
        PostalCode
        Province
        Street
        UnitNum
        Country
        City
      }
    }
  }
}`;

export const GET_COMPANY_ADDRESS_INFO = gql`
query GET_COMPANY_ADDRESS_INFO($filters: CompanyAddressFilterInput) {
  allCompanyAddress(filters: $filters) {
    data {
      OpenFrom
      CloseAt
      WorkingDays
      AllowDoubleDays
      AppointmentStagger
    }
  }
}
`

export const GET_CONSIGNMENT_TRUCK = gql`
query GET_CONSIGNMENT_TRUCK($filters: ConsignmentTruckFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String) {
  allConsignmentTruck(
    filters: $filters
    page: $page
    pageSize: $pageSize
    orderBy: $orderBy
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      ArriveTime
      CompleteStatus
      CompleteTime
      FirstName
      IsConsignor
      IsOEMClient
      IsProcessing
      LaborCost
      LastName
      PalletCost
      SellerCode
      ServiceFee
      StartTime
      TotalPallet
      TruckLoadID
      Type
      FinishedPercen
      IP
    }
  }
}`

export const GET_HOLDING = gql`
query GET_HOLDING($filters: HoldingFilterInput, $orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String) {
  allHolding(
    filters: $filters
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
    search: $search
  ) {
    totalCount
    totalPageNum
    data {
      ID
      item
      Admin
      Reason
      url
    }
  }
}`

export const GET_ONE_PAYMENT_BATCH = gql`
query GET_ONE_PAYMENT_BATCH($id: ID) {
  oneConsignmentPaymentBatch(id: $id) {
    FirstName
    LastName
    GeneratedDate
    PayBatchID
    PayStatus
    SellerCode
    TotalAmount
    TotalCommission
    TotalHighBid
    TotalRefundAmount
    Comment
    PaidDate
  }
}`

export const GET_UNVERIFIED_ITEMS = gql`
query GET_UNVERIFIED_ITEMS($filters: ConsignmentInventoryFilterInput, $pageSize: Int = 100, $page: Int, $search: String, $orderBy: GenericScalar) {
  allConsignmentInventory(
    filters: $filters
    page: $page
    pageSize: $pageSize
    search: $search
    orderBy : $orderBy
  ) {
    data {
      AuctionitemID
      Classification
      Datetime
      HighBid
      ID
      IsConsignor
      Lead
      Location
      LocationCode
      LotID
      MissingStatus
      LotIDString
      Price
      PickupStatus
      ReturnStatus
      SellingOption
      SoldStatus
      TruckAndPallet
      TruckLoadID
      item
      FirstName
      LastName
      ConsignmentPaymentID
      PayBatchID
      PaidDate
      Path
      Settlement
    }
    totalCount
    totalPageNum
  }
}
`

export const CHANGE_VERIFY_STATUS = gql`
mutation CHANGE_VERIFY_STATUS($ConsignmentPaymentID: Int, $VerifyStatus: Int) {
  upsertConsignmentpayment(
    ConsignmentPaymentID: $ConsignmentPaymentID
    VerifyStatus: $VerifyStatus
  ) {
    success
  }
}`

export const MODIFY_CONSIGNMENT_PAYMENT_BATCH = gql`
mutation MODIFY_CONSIGNMENT_PAYMENT_BATCH($PayBatchID: ID, $TotalAmount: Decimal, $TotalCommission: Decimal, $TotalHighBid: Decimal, $TotalRefundAmount: Decimal) {
  upsertConsignmentpaymentbatch(
    PayBatchID: $PayBatchID
    TotalAmount: $TotalAmount
    TotalCommission: $TotalCommission
    TotalHighBid: $TotalHighBid
    TotalRefundAmount: $TotalRefundAmount
  ) {
    success
  }
}`

export const CONSIGNMENT_PAYMENT_SUM_INFO = gql`
query CONSIGNMENT_PAYMENT_SUM_INFO(
  $filters: ConsignmentPaymentFilterInput, 
  $aggregates: ConsignmentPaymentAggregateInput = {
    HighBid: "sum", 
    Settlement: "sum", 
    Commission: "sum", 
    RefundAmount: "sum",
    item: "count"
  }, 
  $groupBy: ConsignmentPaymentGroupByInput = {
    PayBatchID: true, 
    VerifyStatus: true
  }) {
  allConsignmentPayment(
    aggregates: $aggregates
    groupBy: $groupBy
    filters: $filters
  ) {
    aggregateData {
      PayBatchID
      sumCommission
      sumHighBid
      sumSettlement
      sumRefundAmount
      countitem
    }
  }
}`

export const GET_CONSIGNMENT_ITEMS_FOR_PRINT = gql`
query GET_CONSIGNMENT_ITEMS_FOR_PRINT($filters: ConsignmentInventoryFilterInput, $pageSize: Int, $page: Int, $search: String, $orderBy: GenericScalar) {
  allConsignmentInventory(
    filters: $filters
    page: $page
    pageSize: $pageSize
    search: $search
    orderBy: $orderBy
  ) {
    data {
      item
      AuctionitemID
      Lead
      HighBid
      Commission
      RefundAmount
      Settlement
    }
    totalCount
    totalPageNum
  }
}
`;

export const GET_TOTAL_COUNT_AUCTION = gql`
query GET_TOTAL_COUNT_AUCTION($AuctionID: String, $aggregates: Order_ViewAggregateInput = {TotalAmount: "sum"}, $groupBy: Order_ViewGroupByInput = {AuctionID: true}, $orderBy: GenericScalar = ["-AuctionClosedTime", "-AuctionID"], $page: Int, $pageSize: Int) {
  allOrderView(
    aggregates: $aggregates
    groupBy: $groupBy
    orderBy: $orderBy
    filters: {AuctionID: $AuctionID}
    page: $page
    pageSize: $pageSize
  ) {
    aggregateData {
      AuctionID
      sumTotalAmount
    }
  }
}
`;

export const GET_TOTAL_COUNT_BY_TIME = gql`
query GET_TOTAL_COUNT_BY_TIME($filters: Order_ViewFilterInput, $aggregates: Order_ViewAggregateInput = {TotalAmount: "sum"}, $groupBy: Order_ViewGroupByInput = {AuctionID: true}, $orderBy: GenericScalar = ["-AuctionClosedTime", "-AuctionID"], $page: Int, $pageSize: Int) {
  allOrderView(
    aggregates: $aggregates
    groupBy: $groupBy
    orderBy: $orderBy
    filters: $filters
    page: $page
    pageSize: $pageSize
  ) {
    aggregateData {
      AuctionID
      sumTotalAmount
    }
  }
}
`;

export const GET_ALL_PALLET = gql`
query GET_ALL_PALLET($orderBy: GenericScalar, $page: Int, $pageSize: Int, $search: String, $filters: PalletFilterInput) {
  allPallet(
    orderBy: $orderBy
    page: $page
    search: $search
    pageSize: $pageSize
    filters: $filters
  ) {
    data {
      PalletID
      Type
      IsProcessing
      AssignedTo
      CompleteStatus
      StartTime
      CompleteTime
      TruckLoadID
    }
    totalCount
    totalPageNum
  }
}`

export const TRUCK_PALLET_SALESANALYSIS = gql`
query PALLET_SALESANALYSIS($TruckLoadID: String) {
  totalData: allInventory(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
  thrownData: allInventory(
    filters: {TruckLoadID: $TruckLoadID, DescriptionIsnull: true}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
  totalSalesData: allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumUnitPrice
      sumTotalAmount
      countitem
    }
  }
  salesData: allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID, PaymentMethodRegex: "^(?!Unpaid$).+"}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumUnitPrice
      sumTotalAmount
      countitem
    }
  }
  salesUnpaidData: allSalesAnalysis(
    filters: {TruckLoadID: $TruckLoadID, PaymentMethodRegex: "^Unpaid$"}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumUnitPrice
      sumTotalAmount
      countitem
    }
  }
  unsoldAvailableData: allUnSoldItems(
    filters: {TruckLoadID: $TruckLoadID, SellingOptionIn: ["0", "AuctionSelection"]}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
  unsoldSellingData: allUnSoldItems(
    filters: {TruckLoadID: $TruckLoadID, SellingOptionRegex: "^(?!0$)(?!AuctionSelection$).+"}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
}
`;

export const PALLET_SALESANALYSIS = gql`
query PALLET_SALESANALYSIS($TruckAndPallet: String) {
  totalData: allInventory(
    filters: {TruckAndPallet: $TruckAndPallet}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
  thrownData: allInventory(
    filters: {TruckAndPallet: $TruckAndPallet, DescriptionIsnull: true}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
  totalSalesData: allSalesAnalysis(
    filters: {TruckAndPallet: $TruckAndPallet}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumUnitPrice
      sumTotalAmount
      countitem
    }
  }
  salesData: allSalesAnalysis(
    filters: {TruckAndPallet: $TruckAndPallet, PaymentMethodRegex: "^(?!Unpaid$).+"}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumUnitPrice
      sumTotalAmount
      countitem
    }
  }
  salesUnpaidData: allSalesAnalysis(
    filters: {TruckAndPallet: $TruckAndPallet, PaymentMethodRegex: "^Unpaid$"}
    aggregates: {item: "count", TotalAmount: "sum", UnitPrice: "sum"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumUnitPrice
      sumTotalAmount
      countitem
    }
  }
  unsoldAvailableData: allUnSoldItems(
    filters: {TruckAndPallet: $TruckAndPallet, SellingOptionIn: ["0", "AuctionSelection"]}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
  unsoldSellingData: allUnSoldItems(
    filters: {TruckAndPallet: $TruckAndPallet, SellingOptionRegex: "^(?!0$)(?!AuctionSelection$).+"}
    aggregates: {Price: "sum", ID: "count"}
    groupBy: {TruckAndPallet: true}
  ) {
    aggregateData {
      TruckAndPallet
      sumPrice
      countID
    }
  }
}
`;

export const GET_FILTERS_ALLPALLETITEM = gql`
query GET_FILTERS_ALLMANIFESTITEM($filters: InventoryFilterInput) {
  classification: allInventory(
    groupBy: {Classification: true}
    aggregates: {ID: "count"}
    filters: $filters
  ) {
    aggregateData {
      Classification
      countID
    }
  }
}
`;

export const GET_ONE_PALLET = gql`
query GET_ONE_PALLET($id: ID, $filters: PalletFilterInput) {
  onePallet(id: $id, filters: $filters) {
    AssignedTo
    CompleteStatus
    CompleteTime
    IsProcessing
    PalletID
    StartTime
    TruckLoadID
    Type
  }
}`

export const PALLET_DEFECTIVE = gql`
query PALLET_DEFECTIVE($TruckAndPallet: String) {
  ASIS: allQualityInspectionRaw(
    filters: {ItemCondition: "AS IS", TruckAndPallet: $TruckAndPallet}
  ) {
    totalCount
  }
  Thrown: allQualityInspectionRaw(
    filters: {ProcessStatus: "ThrowItAway", ItemConditionIregex: "[^AS IS]", TruckAndPallet: $TruckAndPallet}
  ) {
    totalCount
  }
}
`;

export const GETSUMBYCONDITION_PALLET = gql`
query GETSUMBYCONDITION_PALLET($TruckAndPallet: String) {
  pkgCondition: allQualityInspectionRaw(
    groupBy: {PackageCondition: true}
    aggregates: {ID: "count"}
    filters: {TruckAndPallet: $TruckAndPallet}
  ) {
    aggregateData {
      countID
      PackageCondition
    }
  }
  condition: allQualityInspectionRaw(
    groupBy: {ItemCondition: true}
    aggregates: {ID: "count"}
    filters: {TruckAndPallet: $TruckAndPallet}
  ) {
    aggregateData {
      countID
      ItemCondition
    }
  }
}
`;
